export const defaultFontFamily = '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif';

export const defaultChartConfig = {
  chart: {
    toolbar: { show: false },
    zoom: { enabled: false },
    animations: { enabled: true },
    background: "#fff",
    fontFamily: defaultFontFamily,
    parentHeightOffset: 0,
    offsetX: 0,
    offsetY: 0,
  },
  dataLabels: {
    style: { fontSize: "12px", fontWeight: 500 },
    background: { enabled: false },
  },
  
  grid: {
    show: true,
    borderColor: "#E9ECEF",
    strokeDashArray: 0,
    position: "back",
    xaxis: { lines: { show: false } },
    yaxis: { lines: { show: true } },
    padding: { left: 8, right: 0, top: 0, bottom: 0 }
  },
  legend: {
    fontSize: "12px",
    position: "bottom",
    horizontalAlign: "left",
    markers: { 
      width: 10, 
      height: 10, 
      radius: 50,
      offsetX: -5,
      strokeWidth: 0 
    },
    itemMargin: { horizontal: 12, vertical: 6 },
    onItemClick: { toggleDataSeries: true }
  },
  tooltip: {
    enabled: true,
    theme: "light",
    style: { fontSize: "12px" }
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "65%",
      borderRadius: 0
    }
  }
};

export const donutChartConfig = {
  cutout: "80%",
  plugins: { legend: { display: false } },
  maintainAspectRatio: false,
  responsive: true,
  rotation: -90,
  circumference: 360
};
